import { useRef, CSSProperties } from 'react';
import { useReduxState } from 'hooks';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Text, TextArea } from 'components/common/form';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { FormApi } from 'informed';
import type { HomePageModule } from 'shared-types';
import type { ButtonInterface } from 'components/common/Button';

type HomePageModuleLink = HomePageModule['data']['links'][0];

type Props = {
  buttonCategory?: string;
  buttonIcon?: IconProp;
  buttonProps?: ButtonInterface;
  buttonStyle?: CSSProperties;
  buttonText?: string;
  initialValues?: HomePageModuleLink;
  modalActionText?: string;
  modalTitle?: string;
  onSubmit: (values: HomePageModuleLink) => void;
};

const HomePageSettingsTilesQuickLinksAddOrEdit = ({
  buttonCategory,
  buttonIcon,
  buttonProps,
  buttonStyle,
  buttonText,
  initialValues,
  modalActionText,
  modalTitle,
  onSubmit
}: Props) => {
  const formApi = useRef<FormApi>(undefined);

  const { messages, serverConfig } = useReduxState();

  const handleSubmit = (values: HomePageModuleLink) => {
    if (!values.url) {
      formApi.current.setError('link', messages.commonFieldRequired);
    }
    if (!values.title) {
      formApi.current.setError('title', messages.commonFieldRequired);
    }

    if (!values.url || !values.title) return false;

    onSubmit(values);
  };

  const validateRequired = (value: string) => {
    return !value?.toString().trim() ? messages.commonFieldRequired : undefined;
  };

  return (
    <ModalButtonWithForm
      buttonCategory={buttonCategory}
      buttonIcon={buttonIcon}
      buttonProps={buttonProps}
      buttonStyle={buttonStyle}
      buttonText={buttonText}
      initialValues={initialValues}
      modalActionCategory="success"
      modalActionText={modalActionText}
      modalTitle={modalTitle}
      onSubmit={handleSubmit}
      preventSubmit={true}
      pristineIsValid={false}
      setFormApi={(informedApi: FormApi) => (formApi.current = informedApi)}
    >
      {() => (
        <div>
          <FormGroup label={messages.commonLink}>
            <Text
              field="url"
              id="home-page-custom-link-link"
              placeholder={`${serverConfig.adminUrl}/courses/test-course`}
              validate={validateRequired}
              validateOnChange={true}
            />
          </FormGroup>

          <FormGroup label={messages.commonTitle}>
            <Text
              field="title"
              id="home-page-custom-link-title"
              placeholder={messages.commonTitle}
              validate={validateRequired}
              validateOnChange={true}
            />
          </FormGroup>

          <FormGroup label={messages.commonDescription} labelIsOptional={true}>
            <TextArea
              autoGrow={true}
              field="description"
              id="home-page-custom-link-description"
              maxLength={150}
              placeholder={messages.commonDescriptionPlaceholder}
              preventNewLine={true}
              rows={3}
            />
          </FormGroup>
        </div>
      )}
    </ModalButtonWithForm>
  );
};

export default HomePageSettingsTilesQuickLinksAddOrEdit;
